// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WizardServicos_CancelaServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for wizard_servicos/cancela_servico endpoint
 *
 * Returns a boolean success flag indicating whether the service was cancelled.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type WizardServicos_CancelaServicoResponseDados = boolean;

export type WizardServicos_CancelaServicoResponse = ApiResponse<WizardServicos_CancelaServicoResponseDados>;

registerResponseContract('WizardServicos_CancelaServicoResponse', {})
